import { TextNode, $applyNodeReplacement } from 'lexical'
import type { EditorConfig, NodeKey, SerializedTextNode, Spread } from 'lexical'
import { addClassNamesToElement } from '@lexical/utils'

export type SerializedTextVariableNode = Spread<
  { id: string },
  SerializedTextNode
>

export class TextVariableNode extends TextNode {
  __id: string

  constructor(id: string, label: string, key?: NodeKey) {
    super(label, key)

    this.__id = id
    this.__text = label
  }

  static getType(): string {
    return 'variable'
  }

  static clone(node: TextVariableNode): TextVariableNode {
    return new TextVariableNode(node.__id, node.__text, node.__key)
  }

  static importJSON(
    serializedNode: SerializedTextVariableNode,
  ): TextVariableNode {
    const node = $createTextVariableNode(serializedNode.id, serializedNode.text)
    node.setFormat(serializedNode.format)
    node.setDetail(serializedNode.detail)
    node.setMode(serializedNode.mode)
    node.setStyle(serializedNode.style)

    return node
  }

  exportJSON(): SerializedTextVariableNode {
    return {
      ...super.exportJSON(),
      id: this.__id,
      type: 'variable',
    }
  }

  createDOM(config: EditorConfig): HTMLElement {
    const element = super.createDOM(config)

    addClassNamesToElement(element, config.theme.variable)

    return element
  }

  canInsertTextBefore() {
    return false
  }

  canInsertTextAfter() {
    return false
  }

  isToken() {
    return true
  }

  isTextEntity() {
    return true
  }
}

export function $createTextVariableNode(
  id: string,
  label = '',
): TextVariableNode {
  return $applyNodeReplacement(new TextVariableNode(id, label))
}

export function $isTextVariableNode(node: unknown): node is TextVariableNode {
  return node instanceof TextVariableNode
}
